import { Sort, Type, sort, typeOptions } from "common/entities/IMessage";
import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { Form, Input } from "decorator-form";

const typeSelector = ButtonSelect.registerWithOptions(typeOptions);
const sortSelector = ButtonSelect.registerWithOptions(sort);

@Form({title: "MessageNotification Config"})
export default class MessageNotificationConfig {

    @Input({type: typeSelector, title: "Message Type"})
    public type: Type;

    @Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number=10;

    @Input({type: sortSelector, title: "Sort By"})
    public sort:Sort;

    @Input({type: InputType.NUMBER, title:"Pop Over width"})
    public width:number= 300;

    @Input({type: InputType.NUMBER, title:"Pop Over max height"})
    public maxHeight:number= 500;
    
    @Input({type: InputType.NUMBER, title:"Notification Icon size"})
    public iconSize:number= 30;

}


// WEBPACK FOOTER //
// ./src/panels/message/MessageNotification.ts